"use strict";
import { __require as f } from "./index.es525.js";
var t, p;
function g() {
  if (p) return t;
  p = 1;
  var c = /* @__PURE__ */ f();
  function o() {
  }
  function a() {
  }
  return a.resetWarningCache = o, t = function() {
    function e(u, y, l, h, m, s) {
      if (s !== c) {
        var i = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw i.name = "Invariant Violation", i;
      }
    }
    e.isRequired = e;
    function r() {
      return e;
    }
    var n = {
      array: e,
      bigint: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: r,
      element: e,
      elementType: e,
      instanceOf: r,
      node: e,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: a,
      resetWarningCache: o
    };
    return n.PropTypes = n, n;
  }, t;
}
export {
  g as __require
};
//# sourceMappingURL=index.es510.js.map
